// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3MsW0","label":"Category_label__2a2cq","content":"Category_content__2XY0b","header":"Category_header__1of41","location":"Category_location__3j-c6"};